module.exports = __webpack_public_path__ + "files/60bc5c51264d65c7373acb980707e560.png";